import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Event } from 'src/app/model/event';
import { EventsService } from 'src/app/service/events.service';

/**
 * Só deixa entrar numa página de "Função Extra" se o evento tiver a flag
 * correspondente ligada. A flag vem do `data` da rota:
 *
 *   { path: 'submissions/authors', component: ...,
 *     canActivate: [EventExtraFeatureGuard],
 *     data: { eventFlag: 'tpcBulkCreateUsersEnable' } }
 *
 * Vale pra QUALQUER papel, inclusive o superusuário — o item do menu já é
 * escondido pelo mesmo critério; a guarda é o segundo cerco (URL digitada
 * direto, deep link antigo, botão "voltar" após desligar a função). Flag
 * desligada ou ausente no `data` → redireciona para a home do evento.
 *
 * Uma guarda só para todas as Funções Extras: cada nova flag vira uma linha
 * de rota, não um arquivo novo.
 */
@Injectable({ providedIn: 'root' })
export class EventExtraFeatureGuard implements CanActivate {
  constructor(private eventsService: EventsService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const eventId = Number.parseInt(route.parent?.paramMap.get('eventId') || '', 10);
    const flag = route.data?.eventFlag as keyof Event;
    return this.eventsService.getEvent(eventId).pipe(
      map(ev => (!!flag && !!ev?.[flag]) || this.router.parseUrl(`/admin/${eventId}`))
    );
  }
}
